import { call, put, takeLatest } from "redux-saga/effects";
import { fetchUsersStart, fetchUsersSuccess, fetchUsersFailure, addUserRequest, addUserSuccess, addUserFailure, fetchUserByIdRequest, fetchUserByIdSuccess, fetchUserByIdFailure, updateUserSuccess, updateUserFailure, updateUserRequest } from "../slices/userSlice";
import { ApiResponse, User } from "../types";
import { apiRequestWithAuth } from "../utils/api";
import { createUser, getUser } from "../utils/user";
import { PayloadAction } from "@reduxjs/toolkit";

function* fetchUsersSaga() {
  try {
    const response: ApiResponse<User[]> = yield call(apiRequestWithAuth, "/user", "GET");
    if (response.messageCode == 200) {
      yield put(fetchUsersSuccess(response.result));
    } else {
      yield put(fetchUsersFailure("Failed to fetch users. Message: " + response.message));
    }
  } catch (error) {
    yield put(fetchUsersFailure((error as Error).message));
  }
}

function* handleAddUser(action: ReturnType<typeof addUserRequest>) {
  try {
    const response: ApiResponse<User> = yield call(createUser, action.payload);
    if (response.messageCode === 200) {
      yield put(addUserSuccess(response.result));
    }
  } catch (error) {
    console.error("Lỗi khi thêm user:", error);
  }
}

function* fetchUserByIdSaga(action: ReturnType<typeof fetchUserByIdRequest>) {
  try {
    const response: ApiResponse<User> = yield call(getUser, action.payload);
    if (response.messageCode === 200) {
      yield put(fetchUserByIdSuccess(response.result));
    } else {
      yield put(fetchUserByIdFailure("Failed to fetch user: " + response.message));
    }
  } catch (error: any) {
    yield put(fetchUserByIdFailure(error.message));
  }
}

function* handleUpdateUser(action: PayloadAction<{ id: number; data: Partial<User> }>) {
  try {
    const { id, data } = action.payload;
    const response: Response = yield call(apiRequestWithAuth, `/user/${id}`, "POST", data);
    
    if (!response.ok) throw new Error("Cập nhật user thất bại!");

    const updatedUser: User = yield response.json();
    yield put(updateUserSuccess(updatedUser)); // Dispatch cập nhật Redux
  } catch (error: any) {
    yield put(updateUserFailure(error.message));
  }
}

export function* watchFetchUsers() {
  yield takeLatest(fetchUsersStart.type, fetchUsersSaga);
  yield takeLatest(addUserRequest.type, handleAddUser);
  yield takeLatest(fetchUserByIdRequest.type, fetchUserByIdSaga);
  yield takeLatest(updateUserRequest.type, handleUpdateUser);
}
